export enum RequestPaths {
  Cart = 'cart',
  Checkout = 'checkout',
  ChooseCourt = 'choose-court',
  Confirmation = 'confirmation',
  CourtSystem = 'court-system',
  Courthouse = 'courthouse',
  Courtroom = 'courtroom',
  Department = 'department',
  Recordings = 'recordings',
  Transcripts = 'transcripts',
}

export enum RequestParams {
  RequestType = 'requestType',
  CourtSystemId = 'courtSystemId',
  CourthouseId = 'courthouseId',
  CourtroomId = 'courtroomId',
  DepartmentId = 'departmentId',
  StepName = 'stepName',
}

export enum RequestQueryParams {
  CourtroomCalendarDate = 'courtroomCalendarDate',
  RequestRef = 'requestRef',
}
